import {Component, Input, Output, EventEmitter, HostListener, ViewChild, PipeTransform, Pipe } from '@angular/core';

import {UserService} from '../shared/user.service';

@Pipe({
    name: 'memberHasRole',
    pure: false
})
export class MemberHasRole implements PipeTransform {
    transform(options, role, team) {
        if( !role ) {
            return options;
        }
        let teamIds = [];
        let filterByTeam = false;
        if( Array.isArray(team) ) {
            for(var i = 0; i < team.length; i++) {
                const member = team[i];
                if( member.roles.indexOf(role) !== -1 ) {
                    teamIds.push(member.id);
                }
            }
            filterByTeam = true;
        }
        return options.filter(item => {
            if( filterByTeam ) {
                return teamIds.indexOf(item.id) === -1;
            }
            return item.roles.indexOf(role) !== -1
        });
    }
}

@Component({
    selector: 'page-add-writer-component',
    templateUrl: 'page-add-writer.component.html'
})
export class PageAddWriterComponent {
    memberSearchText = '';
    options = [];
    panelOpen = false;

    private _canEdit = false;
    private _listOnly = false;
    private _team = [];
    private _role = 'pageAddWriter';

    @Input('team')
    set team(team) {
        this._team = team;
    }
    get team() {
        return this._team;
    }
    @Input('canEdit') 
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('listOnly') 
    set listOnly(listOnly) {
        this._listOnly = listOnly;
    }
    get listOnly() {
        return this._listOnly;
    }
    @Input('role') 
    set role(role) {
        this._role = role;
    }
    get role() {
        return this._role;
    }

    @Output() teamChanged = new EventEmitter();

    @HostListener('document:click', ['$event'])
    @HostListener('document:keydown.escape')
    closePanel(event) {
        if( !event ) {
            this.panelOpen = false;
            return;
        }
        if( this.panelOpen && !this.teamDropdown.nativeElement.contains(event.target) ) {
            this.panelOpen = false;
        }
    }

    @ViewChild('teamDropdown') teamDropdown;

    constructor(private userService: UserService) {
        this.options = this.userService.getUsers();
    }
    ngAfterContentInit() {
        this.options = this.userService.getUsers();
    }
    isMember(member) {
        return this.team.filter(item => item.id == member.id).length > 0;
    }
    removeRole(member) {
        const role = this.role;
        let i = member.roles.length;
        while(i--) {
            if( member.roles[i] == role ) {
                member.roles.splice(i, 1);
                this.teamChanged.emit({
                    action: 'roleRemoved',
                    data: {
                        role: role,
                        member: member
                    }
                });
            }
        }
    }
    addRole(option) {
        const role = this.role;
        const team = this.team;
        for(var i = 0; i < team.length; i++) {
            const member = team[i];
            if( member.id == option.id && member.roles.indexOf(role) === -1 ) {
                team[i].roles.push(role);
                this.teamChanged.emit({
                    action: 'roleAdded',
                    data: {
                        role: role,
                        member: member
                    }
                });
                break;
            }
        }
    }
    addMember(option) {
        const member = JSON.parse(JSON.stringify(option));
        if( !this.isMember(member) ) {
            this.team.push(member);
        }
        this.addRole(member);
        this.memberSearchText = '';
        this.panelOpen = false;
    }
    removeMember(member) {
        let i = this.team.length;
        while(i--) {
            if(this.team[i].id == member.id) {
                this.removeRole(member);
                break;
            }
        }
    }
    toggleMemberSelect(open) {
        if( open ) {
            setTimeout(() => {
                this.panelOpen = open;
            }, 250);
            return;
        }
        this.panelOpen = !this.panelOpen;
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/page-add-writer.component.ts